module.exports = __webpack_public_path__ + "media/images/icons/SVG/063-2845a817fe14364f18b7b4ff6b36ff8b.svg";